<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      paddingBottom: '20px'
    }"
  >
    <header-o :model="headerData"></header-o>
    <div style="margin-right: 7px; margin-left: 7px; margin-top: -160px">
      <div>
        <div class="past-history-title text-center pading">
          <div
            class="offer-card bg-light pos-rel box-shadow"
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderRadius: '10px'
            }"
          >
            <div
              class="align-items-center"
              style="display: flex; flex-direction: column"
            >
              <div style="width: 100%; height: 190px">
                <img
                  :src="raffleData.banner_url"
                  style="width: 100%; border-radius: 15px; height: 100%"
                />
              </div>
              <div>
                <p
                  style="
                    font-size: 14px;
                    font-weight: 600;
                    margin: 10px !important;
                    color: #373535;
                  "
                >
                  Winners will be announced in
                </p>
              </div>
              <div>
                <p>
                  <span
                    id="days"
                    style="font-size: 26px; font-weight: 500"
                  ></span>

                  <span
                    id="hours"
                    style="font-size: 26px; font-weight: 500"
                  ></span
                  ><span
                    id="mins"
                    style="font-size: 26px; font-weight: 500"
                  ></span
                  ><span
                    id="seconds"
                    style="font-size: 26px; font-weight: 500"
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Winner Section Start -->
        <div
          class="past-history-title text-center pading"
          v-if="
            raffleData.previous_winners != null &&
              raffleData.previous_winners.leaderboard.length != 0
          "
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderRadius: '10px'
            }"
            class="offer-card bg-light radius-5 pos-rel box-shadow pointer"
            style="padding: 1px"
          >
            <div class="winner-section text-center">
              <div class="title" style="margin-top: 10px">
                <span
                  style="
                    font-size: 16px;
                    /* font-weight: lighter; */
                  "
                  >Previous Winners
                </span>
              </div>

              <div
                class="row align-items-center"
                style="
                  display: flex;
                  justify-content: center;
                  margin-right: 0px;
                  margin-left: -30px;
                "
              >
                <div
                  class="col-2"
                  :style="{
                    visibility: !raffleData.previous_winners.leaderboard[1]
                      ? 'hidden'
                      : ''
                  }"
                >
                  <div
                    class="winner-block"
                    style="
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      width: 86px;
                    "
                  >
                    <img
                      src="@/assets/rank-2.svg"
                      alt="rank-2"
                      class="img-fluid"
                    />
                    <span>{{
                      raffleData.previous_winners.leaderboard[1]
                        ? raffleData.previous_winners.leaderboard[1].user_name
                        : "--"
                    }}</span>
                    <span
                      style="font-size: 13px; font-weight: 700"
                      :style="{ color: bgTheme }"
                      >{{
                        raffleData.previous_winners.leaderboard[1]
                          ? raffleData.previous_winners.leaderboard[1].prize +
                            " "
                          : 0
                      }}{{ raffleData.currency_label }}</span
                    >
                  </div>
                </div>
                <div
                  class="col-2"
                  :style="{
                    visibility: !raffleData.previous_winners.leaderboard[0]
                      ? 'hidden'
                      : ''
                  }"
                >
                  <div
                    class="winner-block first-rank"
                    style="
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      width: 86px;
                    "
                  >
                    <img
                      src="@/assets/rank-1.svg"
                      alt="rank-1"
                      class="img-fluid"
                    />
                    <span>{{
                      raffleData.previous_winners.leaderboard[0]
                        ? raffleData.previous_winners.leaderboard[0].user_name
                        : "--"
                    }}</span>
                    <span
                      style="font-size: 13px; font-weight: 700"
                      :style="{ color: bgTheme }"
                      >{{
                        formatNumber(
                          raffleData.previous_winners.leaderboard[0]
                            ? raffleData.previous_winners.leaderboard[0].prize +
                                " "
                            : 0
                        )
                      }}{{ raffleData.currency_label }}</span
                    >
                  </div>
                </div>
                <div
                  class="col-2"
                  :style="{
                    visibility: !raffleData.previous_winners.leaderboard[2]
                      ? 'hidden'
                      : ''
                  }"
                >
                  <div
                    class="winner-block"
                    style="
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      width: 86px;
                    "
                  >
                    <img
                      src="@/assets/rank-3.svg"
                      alt="rank-3"
                      class="img-fluid"
                    />
                    <span>{{
                      raffleData.previous_winners.leaderboard[2]
                        ? raffleData.previous_winners.leaderboard[2].user_name
                        : "--"
                    }}</span>
                    <span
                      style="font-size: 13px; font-weight: 700"
                      :style="{ color: bgTheme }"
                      ><span></span
                      >{{
                        raffleData.previous_winners.leaderboard[2]
                          ? raffleData.previous_winners.leaderboard[2].prize +
                            " "
                          : 0
                      }}{{ raffleData.currency_label }}</span
                    >
                  </div>
                </div>
              </div>
              <p
                style="display: flex; justify-content: center"
                v-if="raffleData.previous_winners.leaderboard.length > 3"
                @click="
                  redirectTo(
                    'concertDetailPage/' +
                      raffleData.previous_winners.id +
                      `?title=${raffleData.previous_winners.title}`
                  )
                "
              >
                +{{ raffleData.previous_winners.leaderboard.length - 3 }} more
                winners
              </p>
            </div>
          </div>
        </div>
        <!-- Winner Section End -->
        <div
          class="past-history-title text-center pading"
          v-if="raffleData.show_theme != 'banner'"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              paddingBottom: '0px',
              paddingTop: '10px',
              borderRadius: '10px'
            }"
            class="offer-card bg-light radius-5 pos-rel box-shadow"
          >
            <div class="history-table">
              <div class="title past-history-title" style="margin-top: 10px">
                <span
                  style="font-size: 16px; font-weight: 500; color: #323232"
                  >{{ raffleData.reward_title }}</span
                >
              </div>

              <div
                class="table-responsive past-history-title"
                style="box-sizing: border-box; padding: 10px 0px"
              >
                <table class="table table-borderless">
                  <thead>
                    <tr
                      style="
                        border-bottom: 1px solid rgb(252 242 242);
                        padding: 10px !important;
                      "
                    >
                      <th style="padding: 10px 0px">
                        <img
                          src="@/assets/Leaderboard Assest/Rank.svg"
                          class="small-icon mx-2"
                          style="margin-left: 0.05rem !important"
                        />
                        <span
                          style="
                            padding-top: 2px;
                            font-weight: 900;
                            font-size: 12px;
                          "
                          >Rank</span
                        >
                      </th>
                      <th style="padding: 10px 0px">
                        <img
                          :src="raffleData.currency_icon"
                          class="small-icon mx-2"
                        />
                        <span
                          style="
                            padding-top: 2px;
                            font-weight: 900;
                            font-size: 12px;
                          "
                          >{{ raffleData.currency_label }}</span
                        >
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      style="padding: 0px 10px"
                      v-for="price in raffleData.prizes"
                    >
                      <td style="font-size: 12px; color: #544E4E;">
                        {{ price.rank_text }}
                      </td>
                      <td class="name" style="font-size: 12px; color: #323232;">
                        {{ price.prize }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="past-history-title text-center pading"
          v-if="bannerType != 'banner'"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderRadius: '10px'
            }"
            class="offer-card bg-light radius-5 padding-5 pos-rel box-shadow"
            style="padding: 2px"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  margin-bottom: 10px !important;
                  color: #373535 !important;
                  font-weight: 500 !important;
                "
                class="myfont"
              >
                {{ raffleData.title }}
              </div>
              <div
                style="
                  overflow-wrap: break-word;
                  font-size: 15px;
                  padding: 5px;
                  color: #585957;
                  font-weight: 600;
                "
              >
                {{ raffleData.description }}
              </div>
            </div>
            <hr style="background-color: #ffffff" />
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  margin-bottom: 0px !important;
                  color: #373535 !important;
                   font-weight: 500 !important;
                "
                class="myfont"
              >
                Rules
              </div>
              <div
                v-html="raffleData.rules"
                style="overflow-wrap: break-word; padding: 5px;   color: #585957;
                  font-weight: 600; font-size: 15px;"
              ></div>
            </div>
          </div>
        </div>
        <div class="past-history-title text-center pading" v-else>
          <div
            class="offer-card bg-light radius-5 padding-20 pos-rel box-shadow"
          >
            <div
              class="row align-items-center"
              style="display: flex; flex-direction: column"
            >
              <div>
                <img :src="raffleData.raffle_banner1" style="width: 100%" />
              </div>
              <hr />
              <div>
                <img :src="raffleData.raffle_banner2" style="width: 100%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import moment from "moment";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        headerTitle: "",
        isRaffleHistory: true,
        showmore: false
      },
      intervalid: null,
      is_shimmer: true,
      targetEventDate: null,
      months: [1, 3, 5, 8, 10], //months have 30 or 28 or 29 days
      raffleData: {},
      remaining_days: 0,
      bannerType: ""
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();
    var self = this;
    this.intervalid = setInterval(function() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var cDateMillisecs = moment().valueOf();
      var tDateMillisecs = moment(self.targetEventDate).valueOf();
      var difference = tDateMillisecs - cDateMillisecs;
      var seconds = Math.floor(difference / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      // self.totaldays=days
      // var isleapYear =
      //   (0 == currentYear % 4 && 0 != currentYear % 100) ||
      //   0 == currentYear % 400
      //     ? 1
      //     : 0;
      // days %= self.months.includes(currentDate.getMonth())
      //   ? currentDate.getMonth() == 1
      //     ? isleapYear == 1
      //       ? 29
      //       : 28
      //     : 30
      //   : 31;
      // self.remaining_days = days;

      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      if (days > 0) {
        days = days < 10 ? "0" + days : days;
      } else {
        document.getElementById("days").style.display = "none";
      }

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      document.getElementById("days").innerText = days + "d:";
      document.getElementById("hours").innerText = hours + "h:";
      document.getElementById("mins").innerText = minutes + "m:";
      document.getElementById("seconds").innerText = seconds + "s ";
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalid);
  },
  methods: {
    formatNumber(value) {
      if (value >= 1000) {
        return (value / 1000).toFixed(value % 1000 === 0 ? 0 : 1) + "k";
      }
      return value.toString();
    },
    getRaffleDataByid(id) {
      axios.all([this.getRaffleByid(id)]).then(
        axios.spread(resp => {
          if (resp.status == 200) {
            var data = resp.data.raffle;
            this.raffleData = resp.data.raffle;
            this.targetEventDate = resp.data.raffle.ends_at;
            this.$store.state.Raffle_currencyLable =
              resp.data.raffle.currency_label;
            this.bannerType = resp.data.raffle.show_theme;
            this.$store.state.headTitle = resp.data.raffle.title;
          }
        })
      );
    },
    showMore() {
      this.leadeboardData = this.fullListData;
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "Raffle";
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
    if (!this.isEmpty(this.$route.params)) {
      this.getRaffleDataByid(this.$route.params.id);
    }
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.vl {
  border-left: 1px solid #b9b9b9;
  height: 106px;
  /* position: absolute; */
  left: 50%;
  margin-left: 7px;
  top: 0;
}
.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 14px;
  line-height: 14px;
  color: #373535;
  font-weight: 200;
}
.table-responsive {
  display: block;
  /* width: 100%; */
  overflow-x: auto;
}
th,
tr {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}

.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 10px;
  line-height: 19px;
  color: #373535;
  font-weight: 200;
}
.myfont {
  margin: 20px;
  font-size: 16px;
  /* font-weight: 700; */
  /* font-family: "Montserrat-bold", sans-serif; */
  overflow-wrap: break-word;
}
.pading {
  padding: 4px;
}
</style>
